import { TableConfig } from '@shared/interfaces/table/table-config';
import { EstimationGroupSearchResult } from '@app/api/dmc';
import { LinkCellComponent } from '@shared/components/table/cells/link-cell/link-cell.component';

export const veeTable: TableConfig<EstimationGroupSearchResult> = {
  id: 'vee-table',
  title: 'vee.title',
  exportable: true,
  copyable: true,
  floatingHeader: true,
  selectable: true,
  saveChanges: true,
  selectableType: "single",
  pageSize: 25,
  columns: [
    {
      title: 'vee.create.name',
      key: 'name',
      cellRenderer: LinkCellComponent,
      cellRendererParams: {
        url: '/vee',
        urlReference: 'id'
      }
    },
    {
      title: 'vee.create.estimateAfter',
      key: 'estimateAfter'
    }
  ]
}
